import { createApi } from '@reduxjs/toolkit/query/react'
import { ClientError, request } from 'graphql-request'
import { GraphQLClientRequestHeaders, Variables } from 'graphql-request/build/esm/types'

import { getCookie } from '@/utils/cookies'

const graphqlBaseQuery =
  ({ baseUrl }) =>
  async ({
    document,
    variables,
    requestHeaders,
  }: {
    document: string
    variables?: Variables
    requestHeaders?: GraphQLClientRequestHeaders
  }) => {
    const requestHeadersWithAuth = {
      ...requestHeaders,
      Authorization: `JWT ${localStorage.getItem('jwt')}`,
      'X-CSRFToken': getCookie('csrftoken'),
    }

    try {
      const result = await request(baseUrl, document, variables, requestHeadersWithAuth)
      return { data: result }
    } catch (error) {
      if (error instanceof ClientError) {
        if (error.response.status === 401) {
          window.location.href = `/login?next=${window.location.pathname}`
        }
        return { error: { status: error.response.status, data: error } }
      }
      return { error: { status: 500, data: error } }
    }
  }

export const graphqlApi = createApi({
  reducerPath: 'graphqlApi',

  baseQuery: graphqlBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_API_URL + '/graphql/',
  }),

  endpoints: () => ({}),

  tagTypes: [
    'gql:application',
    'gql:applicationOffer',
    'gql:applicationGuidelines',
    'gql:applicationMonthlyIncome',
    'gql:appraisalReport',
    'gql:applicationOfferCalcs',
    'gql:applicationCalcs',
    'gql:applicationExpensesCalcs',
    'gql:applicationTitleCalcs',
    'gql:applicationTradelinesCalcs',
    'gql:applicationValuationsCalcs',
    'gql:customerMsgTemplates',
    'gql:investmentClosingDetailsDates',
  ],
})
